import styled from '@emotion/styled';

import {StyledListItem} from '#/List/Item/styles';
import Loading from '#/Loading';
import SelectBox from '#/form/selectable-input/SelectBox';
import {
  Header,
  HeaderLabel,
  IconWrapper,
} from '_/components/form/selectable-input/SelectBox/styles';
import {withStyle} from '_/utilities/types';

import FilterItem from './Item';

/** @deprecated Use EFilter instead. */
export const StyledSelectBox = withStyle(
  SelectBox,
  styled('div', {
    shouldForwardProp: (prop: string): boolean => !['active'].includes(prop),
  })<{active: boolean; expanded: boolean}>`
    ${Header} {
      background-color: ${({active, expanded}): string =>
        active || expanded
          ? 'var(--color-state-active)'
          : 'var(--color-core-white)'};
      height: 24px;
      padding: var(--gutter-very-tiny) var(--gutter-little);

      ${HeaderLabel} {
        font-size: var(--font-size-small);
        font-weight: var(--font-weight-thin);
        margin-right: var(--gutter-little);
        color: ${({active, expanded}): string =>
          active
            ? 'var(--color-core-black)'
            : expanded
              ? 'var(--color-core-black)'
              : 'var(--color-core-link)'};
      }

      ${IconWrapper} {
        svg {
          width: 16px;
          height: 12px;
          ${({active, expanded}): string =>
            active || expanded ? `fill: var(--color-core-black);` : ''}
        }
      }
    }

    ${Loading} object {
      height: 40px;
    }
  `
);

/** @deprecated Use EFilter instead. */
export const StyledFilter = styled.div`
  display: flex;

  ${FilterItem}, ${StyledSelectBox} {
    :not(:last-child) {
      margin-right: var(--gutter-little);
    }
  }

  ${StyledListItem} {
    font-weight: var(--font-weight-thin);
  }
`;
